import React, { createRef, useEffect, ReactElement } from 'react'
import { colorScaleOptions, fillColorScaleLegend } from '../charts/common/colorScale'
import styled from 'styled-components'

type Props = {
    value: string
    onChange: (value: string) => void
}

export default (props: Props): ReactElement => {
    const refs: { [key: string]: React.RefObject<HTMLCanvasElement> } = Object.keys(colorScaleOptions).reduce(
        (obj, key) => ({ ...obj, [key]: createRef() }),
        {}
    )

    useEffect(() => {
        Object.keys(colorScaleOptions).forEach(key => {
            if (refs[key].current) {
                fillColorScaleLegend(colorScaleOptions[key], refs[key].current)
            }
        })
    }, [props.value, refs])

    return (
        <div>
            <label className="control-label">Color scale</label>
            <div className="form-group">
                {Object.keys(colorScaleOptions).map((key, idx) => (
                    <StyledScaleOption key={key}>
                        <input
                            type="radio"
                            value={idx}
                            checked={props.value === key}
                            onChange={(e): void =>
                                props.onChange(Object.keys(colorScaleOptions)[parseInt(e.target.value) || 0])
                            }
                        />
                        <canvas width="100%" height={10} ref={refs[key]} />
                    </StyledScaleOption>
                ))}
            </div>
        </div>
    )
}

const StyledScaleOption = styled.div`
    display: flex;
    align-items: center;
    margin-top: 12px;

    canvas {
        flex: 1;
    }

    input[type='radio'] {
        margin-right: 8px;
    }
`
